module.exports = __webpack_public_path__ + "img/noresults.1449d125.svg";